import { Injectable } from '@angular/core';
import { Socket, SocketIoConfig } from 'ngx-socket-io';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { DeliveryDTO } from '../dtos/delivery.dto';
import { environment } from 'src/environments/environment';
import { PushService } from './pushmsg.service';


@Injectable({
  providedIn: 'root',
})
export class ChatService extends Socket {
  public socketConnected = false;
  constructor(private pushService: PushService) {
    let userToken = localStorage.getItem('userAccessToken');
    let userId = localStorage.getItem('userId');
    let config: SocketIoConfig = { url:""};
    if (userToken && userId) {
      config = {
        url: environment.AUTH_API_URL,
        options: {
          //  path: '/chat',
          query: {
            token: localStorage.getItem('userAccessToken'),
            user: localStorage.getItem('userId'),
            deviceType: 'WEB',
          }
        },
      };
    }
    super(config);

    if (userToken && userId)
      this.socketConnected = true;
  }

  sendMessage(messageData: any) {
    let chatToken = localStorage.getItem('userAccessToken');
    messageData.chatToken = chatToken;
    this.emit('messageSend', messageData);
  }

  sendMessageReceived(data: any) {
    this.emit('messageReceived', data);
  }

  sendMessageRead(data: any) {
    // console.log('read', data);
    this.emit('messageRead', data);
  }

  requestChatHistory(data: any) {
    let chatToken = localStorage.getItem('userAccessToken');
    data.chatToken = chatToken;

    this.emit('chatHistory', data)
  }

  broadcastYesNo(data: any) {
    this.emit('broadcastYesNo', data);
  }

  approveAdmin(data: any) {
    this.emit('approveAdmin', data);
  }

  public getMessageEvent() {
    return this.fromEvent('messageReceive').pipe(map((data) => data));
  }

  public getBroadCastAccept() {
    return new Observable((observer) => {
      const handler = (message: unknown) => observer.next(message);
      this.on('broadcastaccept', handler);
      return () => this.removeListener('broadcastaccept', handler);
    });
  }

  public getMessages() {
    return new Observable((observer) => {
      const handler = (message: any) => {
        const deliveryData = {
          fromUserId: message.fromUserId,
          toUserId: message.toUserId,
          messageId: message.messageId,
        } as DeliveryDTO;
        this.sendMessageReceived(deliveryData);
        observer.next(message);
      };
      this.on('messageReceive', handler);
      return () => this.removeListener('messageReceive', handler);
    });
  }

  public getsenderMessages() {
    return new Observable((observer) => {
      const handler = (message: unknown) => observer.next(message);
      this.on('senderMessage', handler);
      return () => this.removeListener('senderMessage', handler);
    });
  }

  public getReceiptReceivedByServer() {
    return new Observable((observer) => {
      const handler = (message: unknown) => observer.next(message);
      this.on('receivedByserver', handler);
      return () => this.removeListener('receivedByserver', handler);
    });
  }

  public getMessageDeliveredReceipt() {
    return new Observable((observer) => {
      const handler = (message: unknown) => observer.next(message);
      this.on('delivered', handler);
      return () => this.removeListener('delivered', handler);
    });
  }

  public getMessageReadReceipt() {
    return new Observable((observer) => {
      const handler = (message: unknown) => observer.next(message);
      this.on('read', handler);
      return () => this.removeListener('read', handler);
    });
  }

  public getChatHistoryData() {
    return new Observable((observer) => {
      const handler = (message: unknown) => observer.next(message);
      this.on('chatHistoryData', handler);
      return () => this.removeListener('chatHistoryData', handler);
    });
  }
}
